import { withChartLayout } from 'components/common';
import Pharmacy from 'components/features/chart/order-entry/pharmacy/Pharmacy';

const PharmacyPage = withChartLayout('Pharmacy')(Pharmacy);
export default PharmacyPage;
